<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="text-xs-center">
		<v-dialog
			v-model="modal"
			width="500">
			<template v-slot:activator="{ on }">
				<v-btn
					color="lightred"
					dark
					v-on="on">
					Dodaj grupę w sekcji formularza
				</v-btn>
			</template>
			<v-card>
				<v-card-title
					class="headline blue"
					primary-title>
					Dodanie grupy do sekcji {{ section.name }}
				</v-card-title>

				<div class="text-xs-center">
					<v-card-text>
						<span>Podaj nazwę grupy</span>
						<v-flex>
							<v-text-field
								browser-autocomplete="off"
								label="nazwa"
								aria-label="group name"
								for="add-group-modal-name"
								id="add-group-modal-name"
								type="text"
								v-model="newGroup"
								outline
							></v-text-field>
						</v-flex>
					</v-card-text>
				</div>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click="addNewGroup"
					>
						Dodaj
					</v-btn>
					<v-btn
						color="blue"
						@click="closeModal">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		name: "AddSectionModal",

		props: {
			value: Object,
		},

		computed: {
			section: function () {
				return this.form.formSchema.sections[this.form.selected.sectionIndex];
			},
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				},
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
				modal: false,
				newGroup: "",
			};
		},

		methods: {

			addNewGroup() {
				let newObjGroup = {
					name: this.newGroup,
					fields: [],
					final: false,
				};
				this.section.groups.push(newObjGroup);
				this.modal = false;
				this.clearModal();
			},

			closeModal() {
				this.modal = false;
				this.clearModal();
			},

			clearModal() {
				this.newGroup = "";
			},
		},

	};
</script>

<style scoped>
		.theme--dark .red.lighten-2 {
		color: #000;
	}
</style>
